import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const RelatedProductsPopupEvents: AnalyticsBrandSettings = {

  vistaRapidaProductoCrossCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'checkout', 'vista_rapida_producto_cross', 'anadir_producto_cesta', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['16', '17', '198', '20', '48', '58', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  vistaRapidaProductoCrossCatalogoSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-color_${product.color}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'seleccionar_color', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '48'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  vistaRapidaProductoCrossCatalogoSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-talla_${product.sizeCode}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'seleccionar_talla', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  /* TODO: Añadir evento cuando se agregue venta al selector de talla */
  vistaRapidaProductoCrossCatalogoVerComingSoon(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-talla_${product.sizeCode}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'ver_coming_soon', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '48', '58'];

    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  /* TODO: Añadir evento cuando se agregue venta al selector de talla */
  vistaRapidaProductoCrossCatalogoVerBackSoon(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-talla_${product.sizeCode}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'ver_back_soon', partnumber);

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  vistaRapidaProductoCrossAyudaVerGuiaTallas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'vista_rapida_producto_cross', 'ver_guia_tallas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  vistaRapidaProductoCrossCatalogoVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'ver_producto', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['70', '98', '100', '101', '117', '15', '20', '46', '47', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  vistaRapidaProductoCrossCatalogoVerZoom(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let position;
    if (isDefined(product)) {
      position = product.position?.toString();
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'vista_rapida_producto_cross', 'ver_zoom', position);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  vistaRapidaProductoCrossDisponibilidadEnTiendaVerDisponibilidadTienda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'disponibilidad_en_tienda', 'vista_rapida_producto_cross', 'ver_disponibilidad_tienda', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  vistaRapidaProductoCrossNavegacionVerAnterior(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'vista_rapida_producto_cross', 'ver_anterior', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['70', '98', '100', '101', '117', '20', '47', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  vistaRapidaProductoCrossNavegacionVerSiguiente(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'vista_rapida_producto_cross', 'ver_siguiente', partnumber);

    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['70', '98', '100', '101', '117', '20', '47', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  }

};
